import { render, staticRenderFns } from "./Logbook.vue?vue&type=template&id=78c3f823&scoped=true&"
import script from "./Logbook.vue?vue&type=script&lang=ts&"
export * from "./Logbook.vue?vue&type=script&lang=ts&"
import style0 from "./Logbook.vue?vue&type=style&index=0&id=78c3f823&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c3f823",
  null
  
)

export default component.exports